import { ReactNode } from 'react';
import { ItemsTable } from './items-table.component';
import { ViewAll } from './view-all.component';
import { ChipList, type ChipItem } from './chip-list.component';

const CHIPS_LIMIT = 5;
const TABLE_STYLE = {
  minHeight: '30vh',
  maxHeight: '70vh',
  overflow: 'auto',
};

export const ItemsOrViewAll = ({
  label,
  value,
  disableTypography,
  itemName,
  items,
  limit = CHIPS_LIMIT,
}: {
  label: string;
  value?: string | number | ReactNode;
  disableTypography?: boolean;
  items: Array<ChipItem & { id?: string }>;
  itemName: string;
  limit?: number;
}) => {
  return items.length > limit ? (
    <ViewAll
      label={label}
      value={value}
      disableTypography={disableTypography}
      description={`${itemName}s`}
      count={items.length}
      renderContent={(show) => (
        <ItemsTable
          items={items}
          itemName={itemName}
          title={label}
          onClose={() => show(false)}
          tableSx={TABLE_STYLE}
        />
      )}
    />
  ) : (
    <ChipList label={label} items={items} value={value} disableTypography={disableTypography} />
  );
};
